import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import Header from '../common/containers/Header/Header';
import OverduePrompt from '../common/containers/OverduePrompt/OverduePrompt';
import Maintenance from '../common/components/Maintenance/Maintenance';
import PortalIndexPage from './portal/IndexPage';
import { ACTIONS_MAP } from '../../store/permission/consts';
import { getPermission, setPermission } from '../../store/permission/actions';
import styles from './IndexPage.module.less';
import { getMultipleMessages } from '../login/service';
import STATUS_CODE from '../../request/statusCode';

const Home = ({
  isShowConsole,
  isShowProductManagement,
  isShowPrivilegedConsole,
  isShowPrivilegeCheckinConsole,
  getPermission
}) => {
  const [message, setMessage] = useState([]);

  useEffect(() => {
    getMultipleMessages().then(res => {
      if (
        res.statusCode === STATUS_CODE.OK &&
        res.data &&
        res.data.length > 0
      ) {
        const messages = res.data.map(item => item.message);
        setMessage(messages);
      }
    });
  }, []);

  useEffect(() => {
    getPermission({
      types: [
        'console',
        'productManagement',
        'privilegedConsole',
        'privilegeCheckinConsole'
      ],
      actions: [
        ACTIONS_MAP.console,
        ACTIONS_MAP.productManagement,
        ACTIONS_MAP.privilegedConsole,
        ACTIONS_MAP.privilegeCheckinConsole
      ],
      setPermission
    });
  }, [getPermission]);

  return (
    <div className={styles.IndexPage}>
      <Header
        isShowConsole={isShowConsole}
        isShowProductManagement={isShowProductManagement}
        isShowPrivilegedConsole={isShowPrivilegedConsole}
        isShowPrivilegeCheckinConsole={isShowPrivilegeCheckinConsole}
      />
      <Maintenance message={message} />
      <OverduePrompt />
      <Switch>
        <Route component={PortalIndexPage} />
      </Switch>
    </div>
  );
};

Home.propTypes = {
  isShowConsole: PropTypes.bool.isRequired,
  isShowProductManagement: PropTypes.bool.isRequired,
  isShowPrivilegedConsole: PropTypes.bool.isRequired,
  isShowPrivilegeCheckinConsole: PropTypes.bool.isRequired,
  getPermission: PropTypes.func.isRequired
};

export default connect(
  ({ permission }) => {
    const {
      console,
      productManagement,
      privilegedConsole,
      privilegeCheckinConsole
    } = permission;
    return {
      isShowConsole: console,
      isShowProductManagement: productManagement,
      isShowPrivilegedConsole: privilegedConsole,
      isShowPrivilegeCheckinConsole: privilegeCheckinConsole
    };
  },
  {
    getPermission
  }
)(Home);
